import { apiSlice } from './api-slice';
import {
  Response,
  Sortable,
  Workflow,
  WorkflowItem,
  PaginatedWorkflow,
  NewWorkflow,
} from '../models';
import { PAGINATION_SIZE } from '../constants';

export const workflowsApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAllWorkflows: builder.query<
      Response<Sortable<WorkflowItem>>,
      PaginatedWorkflow
    >({
      query: ({ size, ...prams }) => ({
        url: `company/workflowBuilding/workflowList`,
        method: 'GET',
        params: { size: size || PAGINATION_SIZE, ...prams },
      }),
      providesTags: result =>
        result?.data.content.length
          ? result.data.content.map(({ id }) => ({ type: 'Workflow', id }))
          : ['Workflow'],
    }),
    getWorkflowById: builder.query<Response<Workflow>, number | undefined>({
      query: workflowId => ({
        url: `company/workflowBuilding/workflow/${Number(workflowId)}`,
        method: 'GET',
      }),
      providesTags: (_, __, id) => [{ type: 'Workflow', id }],
    }),
    createWorkflow: builder.mutation<Response<Workflow>, NewWorkflow>({
      query: data => ({
        url: 'company/workflowBuilding/workflow',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: () => [{ type: 'Workflow' }],
    }),
    updateWorkflow: builder.mutation<Response<Workflow>, Workflow>({
      query: data => ({
        url: `company/workflowBuilding/workflow/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: result => {
        return [{ type: 'Workflow', id: result?.data.id }];
      },
    }),
    deleteWorkflow: builder.mutation<Response<{ id: number }>, number>({
      query: workflow => ({
        url: `company/workflowBuilding/workflow/${workflow}`,
        method: 'DELETE',
      }),
      invalidatesTags: result => {
        return [{ type: 'Workflow', id: result?.data.id }];
      },
    }),
  }),
});

export const {
  useGetAllWorkflowsQuery,
  useGetWorkflowByIdQuery,
  useCreateWorkflowMutation,
  useUpdateWorkflowMutation,
  useDeleteWorkflowMutation,
} = workflowsApiSlice;
